/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TasksIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TasksIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TasksIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TasksIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 12"
 style={{'--as-1-Z2ienXb': alignSelf,'--mt-2-Z2ienXb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2ienXb': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2ienXb': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2ienXb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2ienXb': opacity,'--w-10-Z2ienXb': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2ienXb': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2ienXb': fill,'--a-7-Z2ienXb': isAnimated ? animation : "none",'--sd-8-Z2ienXb': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2ienXb': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TasksIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.366.377C.601.135.918 0 1.25 0h4.655c.331 0 .65.135.884.377l2.845 2.926c.234.241.366.568.366.91v6.501c0 .341-.132.668-.366.91A1.233 1.233 0 018.75 12h-7.5c-.332 0-.65-.135-.884-.377A1.305 1.305 0 010 10.714V1.286C0 .945.132.618.366.376zM4.26 3.88c.28.207.346.608.145.897L3.24 6.454a.615.615 0 01-.95.08l-.699-.717a.656.656 0 010-.91.613.613 0 01.884 0l.177.182.735-1.058a.614.614 0 01.872-.15zm.791 1.583c0-.355.28-.643.625-.643h2.083c.346 0 .625.288.625.643 0 .355-.28.643-.625.643H5.676a.634.634 0 01-.625-.643zm0 3.402c0-.355.28-.643.625-.643h2.083c.346 0 .625.288.625.643 0 .355-.28.643-.625.643H5.676a.634.634 0 01-.625-.643zm-.646-.632a.655.655 0 00-.145-.897.614.614 0 00-.872.15l-.735 1.058-.177-.182a.613.613 0 00-.884 0 .656.656 0 000 .91l.699.717a.615.615 0 00.95-.08l1.164-1.676z"
 style={{'--f-12-Z2ienXb': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}